<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-08-10 17:39:07
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-12 11:27:59
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\trusteeship\list\components\audit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :title="title" :visible.sync="visible" width="27%" @close="handleClose">
		<div class="yx-color-text-primary mb-20 fz-16">
			<img src="@/assets/public/warning-org.png" class="warn_img" alt="" />
			<span>{{ contnet }}</span>
		</div>
		<el-form :model="disFrom" ref="disFrom" :rules="disRules" v-if="isAllDataView">
			<el-form-item :label="zsName" label-width="100px" prop="userId">
				<zs-partner-select v-model="disFrom.userId" :onlyOnState="true"></zs-partner-select>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确认审核</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { trusteeshipApply } from '@/api/shopManage';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	components: {
		ZsPartnerSelect,
	},
	data() {
		return {
			visible: false,
			title: '提示',
			params: {},
			disFrom: {
				userId: '',
			},
			disRules: {
				userId: [{ required: true, message: '请选择达人', target: 'blur' }],
			},
			contnet: '',
		};
	},
	computed: {
		...mapGetters(['isAllDataView']),
		zsName() {
			return zsRoleType.name;
		},
	},
	methods: {
		show(params, contnet) {
			this.params = params;
			this.contnet = contnet;
			this.visible = true;
		},
		async confirm() {
			const { isAllDataView } = this;
			if (isAllDataView) {
				this.$refs.disFrom.validate(async valid => {
					if (valid) {
						const { code } = await trusteeshipApply({ ...this.params, userId: this.disFrom.userId });
						if (code !== 0) return;
						this.$message.success('操作成功');
						this.$emit('refreshList');
						this.visible = false;
					}
				});
			} else {
				const { code } = await trusteeshipApply({ ...this.params });
				if (code !== 0) return;
				this.$message.success('操作成功');
				this.$emit('refreshList');
				this.visible = false;
			}
		},
		handleClose() {
			if (!this.isAllDataView) return;
			this.disFrom = {
				userId: '',
			};
			this.$refs.disFrom.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.warn_img {
	width: 16px;
	height: 16px;
	margin-bottom: 2px;
	margin-right: 6px;
}
</style>
